<template>
  <div>
    <v-form ref="form" v-model="valid">
      <v-layout>
        <v-flex xs12 sm6 md5 lg4 xl3>
          <SelectProjectStep/>
        </v-flex>
      </v-layout>
      <ProjectClient/>
      <ProjectEnergyCost type="create"/>
      <ProjectGeneratorConfiguration/>
      <div class="text-center">        
        <v-btn
          class="justify-center"
          color="primary"
          @click="tryCalculate()"
        >CALCULAR PROJETO
        </v-btn>
      </div>    
    </v-form>
  </div>
</template>

<script>
  import ProjectClient from "./ProjectClient";
  import ProjectEnergyCost from "./ProjectEnergyCost";
  import ProjectGeneratorConfiguration from "./ProjectGeneratorConfiguration";
  import {mapActions} from "vuex";
  import SelectProjectStep from "./SelectProjectStep";

  export default {
    name: "ProjectClientData",
    components: {
      SelectProjectStep,
      ProjectGeneratorConfiguration, ProjectEnergyCost, ProjectClient
    },
    methods: {
      ...mapActions(['calculateProject']),
      tryCalculate() {
        if (this.$refs.form.validate()) {
          this.calculateProject()
        }
      }      
    },
    data() {
      return {
        valid: false,
      }
    }
  }
</script>

<style scoped>

</style>
